import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import SliderHomeEnum from '../enumerators/slider-home.enum'

export default class SliderHomeComponent {
    constructor() {
        SliderHomeComponent.swipers = []

        if (window.matchMedia('(max-width: 999px)').matches) {
            SliderHomeComponent.strate1()
            SliderHomeComponent.strateVisiter()
            SliderHomeComponent.strateStartTrip()
        }

        SliderHomeComponent.strateDiscover()
        SliderHomeComponent.strateItinerary()
        SliderHomeComponent.strateEvent()
        SliderHomeComponent.strateSejour()
        SliderHomeComponent.initProgressBar()
    }

    static updateProgressBar(width) {
        const progressBar = '[data-element="event-progress-bar"]'

        if (typeof width !== 'undefined') {
            $(progressBar).css('width', `${width}%`)
        }
    }

    static strate1() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_1).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_1).is(':hidden')
        ) {
            const swiperKey = 'strate1-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.13,
                spaceBetween: 10,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    },
                },
            }

            SliderHomeComponent.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    static strateVisiter() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_VISITER).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_VISITER).is(':hidden')
        ) {
            const swiperKey = 'strateVisiter-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.13,
                spaceBetween: 10,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                },
            }

            SliderHomeComponent.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    static strateStartTrip() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_START_TRIP).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_START_TRIP).is(':hidden')
        ) {
            const swiperKey = 'strateStartTrip-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.13,
                spaceBetween: 10,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                },
            }

            SliderHomeComponent.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    static strateDiscover() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_DISCOVER).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_DISCOVER).is(':hidden')
        ) {
            const swiperKey = 'strateDiscover-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.13,
                spaceBetween: 10,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 2.4,
                        spaceBetween: 40,
                        navigation: {
                            nextEl: "[data-pagination='strate-discover-arrow--next']",
                            prevEl: "[data-pagination='strate-discover-arrow--prev']",
                        },
                    },
                },
            }

            SliderHomeComponent.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    static async strateItinerary() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_ITINERARY).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_ITINERARY).is(':hidden')
        ) {
            const swiperImageKey = 'strateItinerary-image-swiper'
            const swiperContentKey = 'strateItinerary-content-swiper'

            const commonOptions = {
                allowTouchMove: false,
                keyboard: true,
                loop: false,
                navigation: {
                    nextEl: "[data-pagination='strate-itinerary-arrow--next']",
                    prevEl: "[data-pagination='strate-itinerary-arrow--prev']",
                },
                lazy: {
                    loadPrevNext: true,
                },
            }
            if (window.matchMedia('(max-width: 999px)').matches) {
                commonOptions.allowTouchMove = true
                commonOptions.slidesPerView = 1.4
                commonOptions.spaceBetween = 20
            }
            if (window.matchMedia('(max-width: 600px)').matches) {
                commonOptions.slidesPerView = 1.1
                commonOptions.spaceBetween = 10
            }

            const optionsImage = {
                ...commonOptions,
                spaceBetween: 40,
                lazy: true,
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 5,
                    modifier: 1,
                    scale: 0.9,
                },
            }

            if (window.matchMedia('(max-width: 999px)').matches) {
                optionsImage.effect = 'slide'
                optionsImage.spaceBetween = 20
            }

            if (window.matchMedia('(max-width: 600px)').matches) {
                optionsImage.spaceBetween = 10
            }

            const optionsContent = {
                ...commonOptions,
                effect: 'fade',
                speed: 1000,
                fadeEffect: {
                    crossFade: true,
                },
            }

            const [imageSwiper, contentSwiper] = await Promise.all([
                SliderHomeComponent.initSwiper(
                    swiperImageKey,
                    'strate-itinerary__images__content',
                    optionsImage,
                ),
                SliderHomeComponent.initSwiper(
                    swiperContentKey,
                    'strate-itinerary__content__item',
                    optionsContent,
                ),
            ])

            if (window.matchMedia('(max-width: 999px)').matches) {
                imageSwiper.controller.control = contentSwiper
                contentSwiper.controller.control = imageSwiper
            }
        }
    }

    static async strateEvent() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_EVENT).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_EVENT).is(':hidden')
        ) {
            const swiperImageKey = 'strateEvent-image-swiper'
            const swiperContentKey = 'strateEvent-content-swiper'

            const activeElement = $('[data-event-active]')
            const activeValue = activeElement.attr('data-event-active')

            const commonOptions = {
                allowTouchMove: false,
                keyboard: true,
                loop: false,
                navigation: {
                    nextEl: "[data-pagination='strate-event-arrow--next']",
                    prevEl: "[data-pagination='strate-event-arrow--prev']",
                },
                on: {
                    slideChangeTransitionEnd: () => {
                        const highlightIdActive = $('[data-swiper="strateEvent-content-swiper"]')
                            .find('.swiper-slide-active')
                            .data('id-highlight')
                        const timeLineActiveItem = $('[data-element="event-timeline"]').find(
                            '.strate-event__timeline__content__item.active',
                        )
                        const timeLineActiveItemId = timeLineActiveItem.data('event-id')

                        if (timeLineActiveItemId !== highlightIdActive) {
                            $('[data-trigger="event-timeline-item"]').removeClass('active')
                            $(
                                `[data-trigger="event-timeline-item"][data-event-id="${highlightIdActive}"]`,
                            ).addClass('active')
                            SliderHomeComponent.updateProgressBar(
                                $('[data-trigger="event-timeline-item"].active').data('position'),
                            )
                        }
                    },
                },
                initialSlide: activeValue,
            }
            if (window.matchMedia('(max-width: 999px)').matches) {
                commonOptions.allowTouchMove = true
            }

            const optionsImage = {
                ...commonOptions,
                spaceBetween: 10,
                slidesPerView: 1.1,
                breakpoints: {
                    600: {
                        spaceBetween: 30,
                        slidesPerView: 1.3,
                    },
                    999: {
                        spaceBetween: 40,
                        slidesPerView: 1.01,
                    },
                },
                effect: 'coverflow',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 5,
                    modifier: 1,
                    scale: 0.9,
                },
            }

            if (window.matchMedia('(max-width: 999px)').matches) {
                optionsImage.effect = 'slide'
            }

            const optionsContent = {
                ...commonOptions,
                effect: 'fade',
                speed: 1000,
                fadeEffect: {
                    crossFade: true,
                },
            }

            const trigger = '[data-trigger="event-timeline-item"]'

            const [imageSwiper, contentSwiper] = await Promise.all([
                SliderHomeComponent.initSwiper(
                    swiperImageKey,
                    'strate-event__images__item',
                    optionsImage,
                ),
                SliderHomeComponent.initSwiper(
                    swiperContentKey,
                    'strate-event__content__item',
                    optionsContent,
                ),
            ])

            if (window.matchMedia('(max-width: 999px)').matches) {
                imageSwiper.controller.control = contentSwiper
                contentSwiper.controller.control = imageSwiper
            }

            const swiperContent = SliderHomeComponent.swipers[swiperContentKey]
            const swiperImage = SliderHomeComponent.swipers[swiperImageKey]

            $(trigger).on('click', function () {
                if (!$(this).hasClass('active')) {
                    const eventId = $(this).attr('data-event-id')

                    // get index of content item with highlight id == eventId
                    const index = $(`[data-id-highlight="${eventId}"]`).data('index')

                    $(trigger).removeClass('active')
                    swiperContent.slideTo(index)
                    swiperImage.slideTo(index)

                    $(this).addClass('active')
                    SliderHomeComponent.updateProgressBar($(this).attr('data-position'))
                }
            })
        }
    }

    static strateSejour() {
        if (
            $(SliderHomeEnum.CONTAINER_STRATE_SEJOUR).length > 0 &&
            !$(SliderHomeEnum.CONTAINER_STRATE_SEJOUR).is(':hidden')
        ) {
            const swiperKey = 'strateSejour-swiper'

            const options = {
                mousewheel: {
                    forceToAxis: true,
                },
                slidesPerView: 1.13,
                spaceBetween: 10,
                keyboard: true,
                loop: false,
                passiveListeners: false,
                watchSlidesVisibility: true,
                breakpoints: {
                    600: {
                        slidesPerView: 1.8,
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 2.4,
                        spaceBetween: 40,
                        navigation: {
                            nextEl: "[data-pagination='strate-sejour-arrow--next']",
                            prevEl: "[data-pagination='strate-sejour-arrow--prev']",
                        },
                    },
                },
            }

            SliderHomeComponent.initSwiper(swiperKey, 'customer-card', options)
        }
    }

    static initProgressBar() {
        const initProgress = $('.strate-event__timeline__content__item.active').attr(
            'data-position',
        )
        SliderHomeComponent.updateProgressBar(initProgress)
    }

    static async initSwiper(swiperKey, slideItemClass, options) {
        const slideItem = `[data-swiper="${swiperKey}"] > .${slideItemClass}`

        if ($(slideItem).length === 0) {
            return null
        }

        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')
        if (!SliderHomeComponent.swipers) {
            SliderHomeComponent.swipers = {}
        }
        try {
            const swiperInstance = await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
            SliderHomeComponent.swipers[swiperKey] = swiperInstance
            return swiperInstance
        } catch (error) {
            console.error(`Erreur lors de l'initialisation du swiper ${swiperKey}:`, error)
            return null
        }
    }
}
